/**
 * 资源直传工具（presigned PUT——07 开发文档「上传通过 API 签发短期 presigned URL」）。
 * 流程：POST /admin/assets/presign → PUT uploadUrl → 返回 key 供表单引用。
 */
import type { AssetPresignRequest, AssetPresignResponse } from '@chronospeak/contracts';
import { adminHttp } from '../lib/api';

/** 上传一个文件；失败抛 ApiError/网络错误（调用方负责用户话术） */
export async function uploadFile(purpose: AssetPresignRequest['purpose'], file: File): Promise<string> {
  const presign = await adminHttp.post<AssetPresignResponse>('/admin/assets/presign', {
    filename: file.name,
    mimeType: file.type || 'application/octet-stream',
    sizeBytes: file.size,
    purpose,
  });
  const res = await fetch(presign.uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
      // builder-photo：OSS 对象级公开读——presign 已把该头纳入签名，必须实发（contracts AssetPresignResponse.uploadHeaders）
      ...(presign.uploadHeaders ?? {}),
    },
    body: file,
  });
  if (!res.ok) throw new Error(`上传失败（${res.status}）`);
  return presign.key;
}
